import moment from 'moment';

export const BEGINNING_DATE = moment.utc('1970-01-01T00:00:00Z');
export const FAR_FUTURE_DATE = moment.utc('2030-01-01T00:00:00Z');
